<template>
  <div id="cat" v-cloak>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: 'نام کالا', sort: 'name' },
            { title: 'تعداد', sort: 'count' },
            { title: 'قیمت کالا', sort: 'price' },
            { title: 'تاریخ ایجاد', sort: 'createOn' },
            { title: 'مبلغ کمیسیون', sort: 'calculateAmount' },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 33%">
              {{ row.productInfo.name }}
            </td>
            <td style="width: 13%">
              {{ row.productInfo.count }}
            </td>
            <td style="width: 13%; direction: ltr">
              {{ row.productInfo.productPrice }}
            </td>
            <td style="width: 13%">
              {{ row.createOn.split(" ")[0] }}<br />{{
                row.createOn.split(" ")[1]
              }}
            </td>
            <td style="width: 13%">
              {{ row.calculateAmount }}
            </td>
          </template>
        </data-grid>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
export default {
  components: {
    DataGrid,
    "v-select": vSelect,
  },
  props: {
    promoter: {},
  },
  data() {
    return {
      customers: [
        { name: "برداشت و واریز", id: 0 },
        { name: "برداشت", id: 2 },
        { name: "واریز", id: 1 },
      ],
      PartyId: 0,
      gridDataSource: {
        type: "app",
        service: "Credits/api/CommissionsQuery/items",
      },
      gridSearchData: {
        OwnerUserId: this.$route.params.id,
      },
    };
  },
  methods: {},
  watch: {
    show() {
      // this.gridDataSource = {
      //     type: "app",
      //     service: "Promotion/api/PromoterPlanQuery/beneficiary-rules?PromoterPlanId=" + this.currentPlan.id + '&'
      // };
    },
  },
};
</script>
<style scoped>
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
</style>
<style lang="scss">
input[type="checkbox"] {
  -ms-transform: scale(2); /* IE */
  -moz-transform: scale(2); /* FF */
  -webkit-transform: scale(2); /* Safari and Chrome */
  -o-transform: scale(2); /* Opera */
  transform: scale(2);
  padding: 10px;
}
.checkboxtext {
  font-size: 1vw;
  font-weight: bold;
  display: inline;
}
</style>
